import {Component, OnInit} from "@angular/core";
import {ApiService} from "../../shared/services/api.service";
import {ActivatedRoute} from "@angular/router";
import {CookieService} from "ngx-cookie-service";

declare interface RouteInfo {
  path: string;
  title: string;
  rtlTitle: string;
  icon: string;
  class: string;
  role: any;
  // children: any;
}

export const ROUTES: RouteInfo[] = [
  {
    path: "/manager/setting",
    title: "Setting",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['Administrator']
    // children: [{title:'Locations', path:"/manager/service-map"},{title: 'Setting', path:'service-map/setting'}]
  },
  {
    path: "/manager/requests",
    title: "Requests",
    rtlTitle: "لوحة القيادة",
    icon: "icon-chart-pie-36",
    class: "",
    role: ['Administrator']
    // children: [{title: 'Categories', path: '/manager/training'},
    //   // {title: 'AddCategory', path: '/manager/edit-category/0'},
    //   // {title: 'AddPost', path: '/manager/post/0'},
    //   {title: 'Posts', path: 'posts'}]
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  test: Date = new Date();
  flag: any;

  constructor(public apiService: ApiService,private cookieService: CookieService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  openSbmenu(i) {
    // var x = document.querySelectorAll(".show");
    // for (let i = 0; i < x.length; i++) {
    //   x[i].classList.remove('show')
    // }
    // document.getElementById(i).classList.add('show');

  }

  reload() {
    window.location.reload();
  }

  // $sideHeaderNav.on('click', 'li a, li .menu-expand', function (e) {
  //   var $this = $(this);
  //   if ($this.parent('li').hasClass('has-sub-menu') || ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
  //     e.preventDefault();
  //     if ($this.siblings('ul:visible').length) {
  //       $this.parent('li').removeClass('active').children('ul').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     } else {
  //       $this.parent('li').addClass('active').children('ul').slideDown().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-down').addClass('zmdi-chevron-up');
  //       $this.parent('li').siblings('li').removeClass('active').find('ul:visible').slideUp().siblings('a').find('.menu-expand i').removeClass('zmdi-chevron-up').addClass('zmdi-chevron-down');
  //     }
  //   }
  // });

  setActiveSubmenu() {
    // console.log(ROUTES);
    // const url = window.location.hash
    // console.log(url.split('#')[1])
    // for(let i=0; i<ROUTES.length; i++){
    //   for(let j=0; j<ROUTES[i].children; j++){
    //     if(ROUTES[i].children[j].path == url){
    //       ROUTES[i].children[j].title = 'test';
    //     }
    //   }
    // }
  }
  isAuthorized(role) {
    this.flag = false;
    const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
    for (let i = 0; i < rolesArray.length; i++) {
      if (role.includes(rolesArray[i])) {
        this.flag = true;
        break;
      }
    }
    return this.flag;
  }

}
